import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext } from 'react';
import { Box } from '@mui/material';
import * as lodash from 'lodash';
import { WeekScheduleElement } from 'console/schedule-editor/week-view';
import { BoilerCascade, HeatingCircuit, TimeInterval, } from 'z3k-config';
import { save2ConfigNewTimeInterval, weekSchedule2IntervalTimeTable, } from 'console/schedule-editor/transform-schedule';
import { useBox } from 'shared/hooks/utils';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { HeatingMode, } from 'z3k-parser/model/z3k-config/20-heating-mode';
const IntervalTimetableSchedule = memo(function IntervalTimetableSchedule(props) {
    const { interval_timetable, selected_hc, is_boiler_zone, heating_mode, validation_result, } = props;
    const { config, replace_config: onChangeConfig } = useContext(Z3KSettingsEditor);
    const configBox = useBox(config);
    const heating_circuits = HeatingCircuit.get.all(config);
    const boiler_cascades = BoilerCascade.get.all(config);
    const time_intervals = TimeInterval.get.all(config);
    const heating_modes = HeatingMode.get.where(config, (hm) => {
        return is_boiler_zone
            ? HeatingMode.hasBoilerMode(hm, heating_circuits, boiler_cascades) &&
                hm.id !== heating_mode.id
            : HeatingMode.hasConsumerMode(hm, heating_circuits, boiler_cascades) &&
                hm.id !== heating_mode.id;
    });
    const onChangeWeekSchedule = useCallback((week_schedule, exist_time_table, exist_time_intervals) => {
        const new_config = save2ConfigNewTimeInterval(configBox.current, weekSchedule2IntervalTimeTable(week_schedule, exist_time_table, exist_time_intervals));
        if (!lodash.isEqual(configBox.current, new_config)) {
            onChangeConfig(new_config);
        }
    }, [onChangeConfig]);
    return (_jsx(Box, { display: "flex", flexGrow: 1, height: 400, width: "100%", children: _jsx(WeekScheduleElement, { interval_timetable: interval_timetable, time_intervals: time_intervals, heating_modes: heating_modes, selected_hc: selected_hc, onChange: onChangeWeekSchedule, is_boiler_zone: is_boiler_zone, hm_id: heating_mode.id, validation_result: validation_result }) }));
});
export { IntervalTimetableSchedule };
